export default __webpack_public_path__ + "static/media/taca_armazem.d4dfd351.png";